import { Box } from '@bpba/ui-components';
import { BorderProps } from 'styled-system';

type TagDescuentoProps = {
  texto: string | undefined;
} & BorderProps;

export const TagDescuento = (props: TagDescuentoProps) => {
  const { texto, ...otherProps } = props;
  if (!texto || texto.trim().length === 0) return <></>;

  return (
    <Box
      display={'block'}
      position={'absolute'}
      backgroundColor={'primary.0'}
      width={'fit-content'}
      padding={'12px 24px'}
      color={'white'}
      fontWeight={'500'}
      zIndex={1}
      fontSize={'16px'}
      borderRadius="inherit"
      borderBottomLeftRadius={['16px', 'unset']}
      borderBottomRightRadius={['unset', '8px']}
      left={['unset', 0]}
      right={[0, 'unset']}
      {...otherProps}
    >
      {texto.trim()}
    </Box>
  );
};
